module.exports = __webpack_public_path__ + "img/apple-appstore-badge.bb7cc113.png";